import React from 'react';
import { NavLink, Link, withRouter, useLocation } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { useIntl } from 'react-intl';
import { getLocalizedName, trimText } from '../../../utility/util/util.service';

const CategoryBreadCrumbs = ({ categories, slug }) => {
  const intl = useIntl();
  const { search } = useLocation();
  return (
    <div className="content-header mb-2">
      <div className="d-flex align-items-center justify-content-start">
        <div className="breadcrumb-wrapper d-sm-block">
          <Breadcrumb tag="div" listClassName="mb-0 p-0" className="p-0">
            {categories?.map((category) => (
              <BreadcrumbItem tag="li" active key={category.id}>
                <Link to={`/store/${slug}/${category.id}${search || ''}`}>
                  {trimText(
                    getLocalizedName(category, intl.locale),
                    30,
                    ' ...',
                  )}
                </Link>
              </BreadcrumbItem>
            ))}
          </Breadcrumb>
        </div>
      </div>
    </div>
  );
};

export default withRouter(CategoryBreadCrumbs);
